module.exports = "<router-outlet></router-outlet>\n<backend-notification></backend-notification>\n<ngx-loading-bar></ngx-loading-bar>\n<div kendoDialogContainer></div>\n"


//////////////////
// WEBPACK FOOTER
// ./apps/frontend/src/bootstrap/app.component.html
// module id = ./apps/frontend/src/bootstrap/app.component.html
// module chunks = main